const DOMAIN = 'cobranded.services.userSettings.privateArea.cbGeneric.cbError.';

const BUTTON = `${DOMAIN}tryAgainButton`,
  ERROR_DESCRIPTION = `${DOMAIN}descriptionV2`,
  ERROR_TITLE = `${DOMAIN}titleV2`;

export { BUTTON, ERROR_DESCRIPTION, ERROR_TITLE };
